import FormContrato from '../componentes/FormContrato.vue'
import ListaContrato from '../componentes/ListaContrato.vue'


const routes = [
    ...route('/guardar-contrato', FormContrato, {
        Auth: true,
        ///req_admin: true
     }),
     ...route('/lista-contrato', ListaContrato, {
       Auth: true,
       //req_admin: true
    }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes